import styled from 'styled-components';

export const TooltipContent = styled.div`
  padding: 8px;
`;
